import axios from 'axios'
import API from '@/common/api'
import store from '..'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    guestInfo: null
  },
  mutations: {
  },
  actions: {
    async getCheckoutStatus ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/checkout`, {
          cmd: 'sc-request-api',
          func: 'get-checkout-status',
          siteid: data.siteid,
          spaceid: data.spaceid,
          key: data.key
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async setCheckout ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/checkout`, {
          cmd: 'sc-request-api',
          func: 'request-mobile-checkout',
          siteid: data.siteid,
          spaceid: data.spaceid,
          key: data.key
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getGuestInfo ({ state }) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-guest',
          func: 'get-guest-info',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k
        })
        if (res && res.data && res.data.message) {
          state.guestInfo = res.data.message
        }
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getMorningcall ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-morning-call',
          func: 'get-morning-call-list',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: data.key
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async setMorningcall ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-morning-call',
          func: 'set-morning-call',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: data.key,
          data: data.data
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async clearMorningcall ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-morning-call',
          func: 'clear-morning-call',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: data.key,
          order_uuid: data.id
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async getParking ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-parking',
          func: 'get-parking-list',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: data.key
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async getMobilityPreset ({ dispatch, state }) {
      const file = 'features/mobility_preset.json'
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`).then(res => {
        return res.data.message
      }).catch((ex) => {
        return false
      })
    },
    async getMobilityOrigin ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'get-mobility-origin',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k
        })
        return res && res.data && res.data.message ? res.data.message : res.response && res.response.data
      } catch (ex) {
        // console.log(ex)
        console.log(ex)
        return ex && ex.response
      }
    },
    async setParking ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-parking',
          func: 'set-parking',
          siteid: data.siteid,
          spaceid: data.spaceid,
          ota: data.key,
          data: data.data
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getMobilityList ({ state }) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'get-mobility-list',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k
        })
        return res && res.data && res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async setDestination ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'set-destination',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          data: {
            phone: data.phone,
            origin: data.origin,
            destination: data.destination,
            waypoints: data.waypoints
          }
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async getPickup ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'get-pickup',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          accessToken: data.accessToken,
          data: {
            serviceType: data.serviceType,
            origin: data.origin,
            destination: data.destination,
            waypoints: data.waypoints
          }
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getServiceDesc ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'get-service-desc',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          accessToken: data.accessToken,
          data: {
            serviceType: data.serviceType,
            origin: data.origin
          }
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return ex && ex.response
      }
    },
    async requestRide ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'request-ride',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          accessToken: data.accessToken,
          data: {
            phone: data.phone,
            serviceType: data.serviceType,
            origin: data.origin,
            destination: data.destination,
            waypoints: data.waypoints,
            serviceToken: data.serviceToken,
            pickupPointToken: data.pickupPointToken
          }
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async requestDestLessRider ({ state }, data) { // 목적지 없는 호출
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'request-dest-less-ride',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          accessToken: data.accessToken,
          data: {
            phone: data.phone,
            origin: data.origin
          }
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async cancelRide ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-mobility',
          func: 'cancel-ride',
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k,
          lang: data.lang,
          service: data.service,
          rideId: data.rideId
        })
        return res.data.message
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getPlace ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const apiKey = 'AIzaSyCg54Eflz1DcKXOCT42M3nYyOLs_SL13Lg'
        const languageCode = router.currentRoute.params.ln
        const res = await axios.post(`https://places.googleapis.com/v1/places:searchText`,
          {
            languageCode: languageCode,
            textQuery: data
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-Goog-FieldMask': 'places.id,places.displayName,places.shortFormattedAddress,places.formattedAddress,places.location',
              'X-Goog-Api-Key': apiKey
            }
          })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    }
  },
  getters: {
    getGuestInfo: state => state.guestInfo
  }
}
